import { showHttpError } from '@calendly/alert'
import { httpRequest, buildQuery } from '@calendly/http-tools'
import { createSlice } from '@reduxjs/toolkit'

import { redirectToAuthorizeUrl } from 'actions/omniauth'

import { newFormUrl } from './url'

const sliceName = 'routingFormsEditPage'

const initialState = {
  isDirty: null,
  isNewFormPopupOpen: false,
  isPublishFormPopupOpen: false,
  isPermissionsPopupOpen: false,
  isExternalFormPopupOpen: false,
  isPreviewOpen: false,
  editingButton: null,
  editedField: null,
  route: null,
  businessUnitId: null,
  externalObjectName: null
}

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setIsPublishFormPopupOpen(state, { payload }) {
      state.isPublishFormPopupOpen = payload
    },
    setIsPermissionsPopupOpen(state, { payload }) {
      state.isPermissionsPopupOpen = payload
    },
    setIsExternalFormPopupOpen(state, { payload }) {
      state.isExternalFormPopupOpen = payload
    },
    setDeletingRoute(state, { payload }) {
      state.deletingRoute = payload
    },
    setIsPreviewOpen(state, { payload }) {
      state.isPreviewOpen = payload
    },
    setEditedField(state, { payload }) {
      state.editedField = payload
    },
    setEditingButton(state, { payload }) {
      state.editingButton = payload
    },
    setBusinessUnitId: (state, { payload }) => {
      state.businessUnitId = payload
    },
    setIsDirty: (state, { payload: isDirty }) => {
      state.isDirty = isDirty
    },
    setExternalObjectName: (state, { payload: externalObjectName }) => {
      state.externalObjectName = externalObjectName
    },
    openNewFormPopup: (state) => {
      state.isNewFormPopupOpen = true
    },
    closeNewFormPopup: (state) => {
      state.isNewFormPopupOpen = false
    },
    resetFormState: (state) => ({
      ...initialState,
      isExternalFormPopupOpen: state.isExternalFormPopupOpen
    })
  }
})

export const {
  setEditedField,
  setEditingButton,
  setIsPublishFormPopupOpen,
  setIsPermissionsPopupOpen,
  setIsExternalFormPopupOpen,
  setIsPreviewOpen,
  setDeletingRoute,
  setIsDirty,
  resetFormState,
  openNewFormPopup,
  closeNewFormPopup,
  setBusinessUnitId,
  setExternalObjectName
} = slice.actions

const requestData = (options) => async (dispatch) => {
  const [success, response] = await httpRequest(options)

  if (!success) {
    dispatch(showHttpError(response))
  }

  return [success, response]
}

export const previewFormSubmission = (formId, values) => (dispatch) => dispatch(requestData({
  url: `/api/form_builder/forms/${formId}/preview`,
  method: 'POST',
  data: values
}))

export const connectPardot = () => async (dispatch) => {
  const queryString = buildQuery({
    origin: newFormUrl('intake/pardot'),
    no_sync: 1
  }, { addQueryPrefix: true })

  dispatch(redirectToAuthorizeUrl(`/users/auth/pardot${queryString}`))
}

export const connectHubspot = () => async (dispatch) => {
  const queryString = buildQuery({
    origin: newFormUrl('intake/hubspot'),
    no_sync: 1
  }, { addQueryPrefix: true })

  dispatch(redirectToAuthorizeUrl(`/users/auth/hubspot_oauth2${queryString}`))
}

export const reducerObject = { [sliceName]: slice.reducer }
